import { useContext } from 'react';
import { getCookie, setCookie } from '@services/cookies';
import { GlobalContext } from '@store/global-state';
import { COOKIES, COOKIE_EXPIRES_IN } from '@constants/cookies';

export const useDetectLocale = () => {
  const { setCurrencyCode } = useContext(GlobalContext);

  const detectLocale = () => {
    const isCurrencySet = getCookie(COOKIES.currency);
    if (!isCurrencySet) {
      setCookie(COOKIES.currency, 'GBP', COOKIE_EXPIRES_IN.thirtyDays);
      setCurrencyCode('GBP');
    }
    setCookie(COOKIES.userCountry, 'GB', COOKIE_EXPIRES_IN.thirtyDays);
  };

  return { detectLocale };
};
